(function (window, document) {
  'use strict';

  function getBoxes() {
    return Array.from(document.querySelectorAll('[data-aw-term]'));
  }

  function isValid() {
    const boxes = getBoxes();
    return boxes.length > 0 && boxes.every((box) => box.checked);
  }

  function publish() {
    document.dispatchEvent(new CustomEvent('alwan:terms:update', {
      detail: { valid: isValid() }
    }));
  }

  function init() {
    getBoxes().forEach((box) => box.addEventListener('change', publish));
    publish();

    window.AlwanTerms = {
      isValid
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
